import React, { useEffect, useState } from 'react';
import { isStorySeen } from '../lib/stories';
import StoriesViewer from './StoriesViewer';

/**
 * Stories — Instagram-style ring strip at the top of the home feed.
 * Each ring is a business with upcoming events; tapping opens StoriesViewer.
 */
export default function Stories({ stories, analytics, loading = false }) {
    const [activeIndex, setActiveIndex] = useState(null);
    const [seen, setSeen] = useState([]);

    useEffect(() => {
        const sync = () => setSeen((stories || []).map((s) => s.businessId).filter(isStorySeen));
        sync();
        window.addEventListener('pw:stories-seen-changed', sync);
        return () => window.removeEventListener('pw:stories-seen-changed', sync);
    }, [stories]);

    if (loading) {
        return (
            <div className="stories-strip">
                <div className="stories-strip__row">
                    {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
                        <div key={i} className="flex flex-col items-center gap-1.5 mx-1.5">
                            <span className="story-ring">
                                <span className="block w-14 h-14 rounded-full bg-gray-200 animate-pulse" />
                            </span>
                            <span className="block w-14 h-2.5 rounded bg-gray-200 animate-pulse" />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    if (!stories || stories.length === 0) return null;

    const handleOpen = (index) => {
        if (analytics) analytics.trackInteraction('click_story', { businessId: stories[index].businessId });
        setActiveIndex(index);
    };

    return (
        <div className="stories-strip">
            <div className="stories-strip__row">
                {stories.map((story, index) => {
                    const viewed = seen.includes(story.businessId);
                    return (
                        <button
                            key={story.businessId}
                            type="button"
                            onClick={() => handleOpen(index)}
                            className="stories-strip__ring no-underline"
                            aria-label={`View stories for ${story.businessTitle}`}
                        >
                            <span className={`story-ring${viewed ? ' story-ring--seen' : ''}`}>
                                    <img
                                        src={story.avatarUrl}
                                        alt=""
                                        className="w-14 h-14 rounded-full object-cover bg-white border-2 border-white"
                                        loading="lazy"
                                    />
                                </span>
                            <span className="stories-strip__label">{story.businessTitle}</span>
                        </button>
                    );
                })}
            </div>

            {activeIndex !== null && (
                <StoriesViewer
                    stories={stories}
                    startIndex={activeIndex}
                    onClose={() => setActiveIndex(null)}
                    analytics={analytics}
                />
            )}
        </div>
    );
}